import { render, staticRenderFns } from "./ImageItem2Template.vue?vue&type=template&id=4ae2fecb"
import script from "./ImageItem2Template.vue?vue&type=script&lang=js"
export * from "./ImageItem2Template.vue?vue&type=script&lang=js"
import style0 from "./ImageItem2Template.vue?vue&type=style&index=0&id=4ae2fecb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports